/**
 * Created by saha.moinak on 02/07/2020.
 */
import reducerRegistry from '@comeon/reducer-registry';
import { requestApi } from '~/services/api.js';

export const UPDATE_MY_NOTIFICATIONS_LIST = '@komigen/mobile-frontend/myNotifications/UPDATE_MY_NOTIFICATIONS_LIST';
export const MARK_ALL_READ_COMMUNICATION_NOTIFICATION =
	'@komigen/mobile-frontend/myNotifications/MARK_ALL_READ_COMMUNICATION_NOTIFICATION';
export const MARK_READ_COMMUNICATION_NOTIFICATION =
	'@komigen/mobile-frontend/myNotifications/MARK_READ_COMMUNICATION_NOTIFICATION';
export const MARK_RECEIVED_COMMUNICATION_NOTIFICATION =
	'@komigen/mobile-frontend/myNotifications/MARK_RECEIVED_COMMUNICATION_NOTIFICATION';
export const CLEAR_COMMUNICATION_NOTIFICATION =
	'@komigen/mobile-frontend/myNotifications/CLEAR_COMMUNICATION_NOTIFICATION';
export const ADD_NOTIFICATION_TO_POPUP_QUEUE =
	'@komigen/mobile-frontend/myNotifications/ADD_NOTIFICATION_TO_POPUP_QUEUE';
export const REMOVE_NOTIFICATION_FROM_POPUP_QUEUE =
	'@komigen/mobile-frontend/myNotifications/REMOVE_NOTIFICATION_FROM_POPUP_QUEUE';
export const UPDATE_BLUEBAR_NOTIFICATION = '@komigen/mobile-frontend/myNotifications/UPDATE_BLUEBAR_NOTIFICATION';
export const UPDATE_NOTIFICATION_POPUP_ADDITIONAL_DATA =
	'@komigen/mobile-frontend/myNotifications/UPDATE_NOTIFICATION_POPUP_ADDITIONAL_DATA';

const REDUCER_NAME = 'myNotifications';

const addNotificationPopupToQueue = notificationId => ({
	type: ADD_NOTIFICATION_TO_POPUP_QUEUE,
	payload: notificationId
});

const removeNotificationPopupFromQueue = notificationId => ({
	type: REMOVE_NOTIFICATION_FROM_POPUP_QUEUE,
	payload: notificationId
});

const updateBluebarNotification = notification => ({
	type: UPDATE_BLUEBAR_NOTIFICATION,
	payload: notification
});

const markAllRead = () => {
	return async (dispatch, getState) => {
		dispatch({
			type: MARK_ALL_READ_COMMUNICATION_NOTIFICATION
		});

		const response = await requestApi('/player-notifications/states/user/markallasread', {}, 'PUT');

		const notifications = getState().myNotifications.allNotifications;

		response.forEach(notificationId => {
			const notificationToUpdate = notifications[notificationId];

			if (notificationToUpdate) {
				// if we are able to mark a notification as read, we sure as hell received it.
				notificationToUpdate.readNotification = true;

				if (!notificationToUpdate.receivedNotification) {
					notificationToUpdate.receivedNotification = Date.now();
				}

				// if we read a notification with a popup that was in the popup queue
				// but was not yet shown due to display rules, we should remove it
				// from popup queue as well
				dispatch(removeNotificationPopupFromQueue(notificationToUpdate.id));
			}
		});
		dispatch({
			type: UPDATE_MY_NOTIFICATIONS_LIST,
			payload: Object.values(notifications)
		});
	};
};

const markRead = id => {
	return async (dispatch, getState) => {
		dispatch({
			type: MARK_READ_COMMUNICATION_NOTIFICATION
		});

		const response = await requestApi(`/player-notifications/states/user/markread/${id}`, {}, 'PUT');

		const notifications = getState().myNotifications.allNotifications;

		const notificationToUpdate = { ...notifications[response] };

		if (notificationToUpdate) {
			// if we are able to mark a notification as read, we sure as hell received it.
			notificationToUpdate.readNotification = true;
			if (!notificationToUpdate.receivedNotification) {
				notificationToUpdate.receivedNotification = Date.now();
			}
			// if we read a notification with a popup that was in the popup queue
			// but was not yet shown due to display rules, we should remove it
			// from popup queue as well
			dispatch(removeNotificationPopupFromQueue(notificationToUpdate.id));
		}
		dispatch({
			type: UPDATE_MY_NOTIFICATIONS_LIST,
			payload: [notificationToUpdate]
		});
	};
};

const markReceived = id => {
	return async (dispatch, getState) => {
		dispatch({
			type: MARK_RECEIVED_COMMUNICATION_NOTIFICATION
		});

		requestApi(`/player-notifications/states/user/markreceived/${id}`, {}, 'PUT');

		const notifications = getState().myNotifications.allNotifications;

		const notificationToUpdate = { ...notifications[id] };

		if (notificationToUpdate) {
			notificationToUpdate.receivedNotification = Date.now();
		}
		dispatch({
			type: UPDATE_MY_NOTIFICATIONS_LIST,
			payload: [notificationToUpdate]
		});
	};
};

const updateMyNotificationsList = newNotificationsArr => ({
	type: UPDATE_MY_NOTIFICATIONS_LIST,
	payload: newNotificationsArr
});

const clearNotifications = () => ({
	type: CLEAR_COMMUNICATION_NOTIFICATION
});

const updateMyNotificationsPopupAdditionalData = (additionalData = null) => ({
	type: UPDATE_NOTIFICATION_POPUP_ADDITIONAL_DATA,
	payload: additionalData
});

function reducer(
	state = {
		allNotifications: {},
		popupQueue: {},
		bluebarNotification: null,
		unreadCount: 0,
		notificationCategories: [`INBOX_CATEGORY_ALL`],
		popupAdditionalData: null
	},
	action
) {
	let popupNotification = null;
	switch (action.type) {
		case MARK_RECEIVED_COMMUNICATION_NOTIFICATION:
		case MARK_ALL_READ_COMMUNICATION_NOTIFICATION:
			return {
				...state
			};
		case UPDATE_MY_NOTIFICATIONS_LIST: {
			const notifications = { ...state.allNotifications };

			// This section(Loop) should only be used to update the notification state.
			// Nothing else.
			action.payload.forEach(notification => {
				if (notification?.data && typeof notification.data === 'string') {
					try {
						notification.data = JSON.parse(notification.data); // eslint-disable-line no-param-reassign
					} catch (e) {
						console.log(e); // eslint-disable-line
					}
				} else if (!notification?.data) {
					// eslint-disable-next-line no-param-reassign
					notification.data = {
						NotificationCategory: `INBOX_CATEGORY_ALL`
					};
				}
				notifications[notification.id] = notification;
			});

			let count = 0;

			Object.values(notifications).forEach(notificationItem => {
				if (!notificationItem.readNotification) {
					count += 1;
				}
			});

			return {
				...state,
				allNotifications: notifications,
				unreadCount: count
			};
		}
		case CLEAR_COMMUNICATION_NOTIFICATION:
			return {
				...state,
				allNotifications: {},
				popupQueue: {},
				unreadCount: 0,
				notificationCategories: [`INBOX_CATEGORY_ALL`]
			};
		case ADD_NOTIFICATION_TO_POPUP_QUEUE: {
			popupNotification = state.allNotifications[action.payload];

			const newQueue = { ...state.popupQueue };

			newQueue[popupNotification.id] = popupNotification;

			return {
				...state,
				popupQueue: newQueue
			};
		}
		case REMOVE_NOTIFICATION_FROM_POPUP_QUEUE: {
			const newQueue = { ...state.popupQueue };
			if (Object.hasOwn(newQueue, action.payload)) {
				delete newQueue[action.payload];
			}

			return {
				...state,
				popupQueue: newQueue
			};
		}
		case UPDATE_BLUEBAR_NOTIFICATION:
			return {
				...state,
				bluebarNotification: action.payload
			};
		case UPDATE_NOTIFICATION_POPUP_ADDITIONAL_DATA:
			return {
				...state,
				popupAdditionalData: action.payload
			};

		default:
			return state;
	}
}

reducerRegistry.register(REDUCER_NAME, reducer);

export {
	markAllRead,
	markRead,
	markReceived,
	updateMyNotificationsList,
	clearNotifications,
	addNotificationPopupToQueue,
	removeNotificationPopupFromQueue,
	updateBluebarNotification,
	updateMyNotificationsPopupAdditionalData
};

export default reducer;
